import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RouteComponentProps } from 'react-router-dom';
import { StaticContext } from 'react-router';
import { createBrowserHistory } from 'history';
import createRootReducer from 'redux/reducers';

import { configureStore } from 'core/redux/hooks';
import { sendActionToGtm } from 'utils/analytics/googleAnalytics';

const ignoredActions = ['core/progressEnd', 'core/progressStart'];

export const GTMStatisticMiddleware = (store: any) => (next: any) => (action: any) => {
  // if (action.type.endsWith('_REQUEST')) {
  //   return;
  // }

  const result = next(action);

  if (!ignoredActions.includes(action.type)) {
    sendActionToGtm(action, store);
  }

  return result;
};

const history = createBrowserHistory();
const rootReducer = createRootReducer(history);
const store = configureStore(rootReducer, history);

export default store;
export { history, store };
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, AnyAction>;
export type AppRouteComponentProps = RouteComponentProps<
  { lang?: string },
  StaticContext,
  { login?: string } | undefined
>;
